import styled from '@emotion/styled';
import { Page } from '../../../../components-dummy';

export const PageStyled = styled(Page)`
  background-color: #ffffff;
  .syte-page-content {
    margin-bottom: 90px;
  }
`;
